import React from "react";
import store from "../../Redux/Store";

const TitleSection = ({ text }) => {
  const { appType } = store.getState().uiReducers;

  return (
    // ${appType === "Business" ? "text-dark " : "text-org"}
    <div class={`mb-0  h3 headingColor `}>{text}</div>
  );
};
export default TitleSection;
